import "./style.scss";

function ImageHead({ imgUrl }) {
    return (<div className="dfc-image-header">
        <img src={imgUrl} alt="head image" />
    </div>);
}

export default ImageHead;